
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.768 1.909a1.783 1.874 0 00-1.03-.345H3.285c-.493 0-.942.213-1.269.556a1.81 1.904 0 00-.352.522 1.775 1.866 0 00-.176.812v13.092c0 .518.202.991.528 1.334.327.343.776.555 1.269.555h12.453c.493 0 .943-.212 1.268-.555.327-.344.529-.816.529-1.334V8.785l1.488-1.554v9.315c0 .951-.37 1.815-.965 2.44A3.197 3.197 0 0115.738 20H3.285a3.131 3.131 0 01-1.563-.418 3.357 3.357 0 01-.758-.596A3.533 3.533 0 010 16.546V3.454c0-.178.013-.353.038-.524.004-.03.01-.059.015-.088a3.691 3.691 0 01.075-.34l.02-.073c.161-.54.445-1.025.816-1.416A3.2 3.2 0 013.285 0h12.453c.81 0 1.553.312 2.127.826z"}}),_c('path',{attrs:{"d":"M19.85 3.918l-1.374-1.445a.508.534 0 00-.72 0l-8.155 8.576-3.662-3.85a.508.534 0 00-.72 0L3.846 8.645a.508.534 0 000 .756l3.897 4.097a.542.542 0 00.101.153l1.375 1.446a.508.534 0 00.72 0L19.85 4.675a.508.534 0 000-.757z","clip-rule":"evenodd","fill-rule":"evenodd"}})])
          )
        }
      }
    